/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Instalar o Bumble",
      "Aceitar tudo",
      "Gerir opções",
      "Política de Cookies",
      "Voltar",
      "Número de telefone incorreto",
      "© {{current_year}} Bumble | Todos os direitos reservados.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Sobre",
      "Embaixadores",
      "O Buzz",
      "Este site utiliza cookies. Se não alterares as tuas definições, isso significa que concordas com o uso de cookies.",
      "Instalar a App",
      "Instalar para Android",
      "Instalar para iOS",
      "Página não encontrada.",
      "Entrar",
      "Entrar",
      "Junta-te à Colmeia!",
      "Ups, ocorreu um problema"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "dias"
            ],
            "singular": [
                  "dia"
            ]
      },
      "hour": {
            "plural": [
                  "horas"
            ],
            "singular": [
                  "hora"
            ]
      },
      "minute": {
            "plural": [
                  "minutos"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "meses"
            ],
            "singular": [
                  "mês"
            ]
      },
      "second": {
            "plural": [
                  "segundos"
            ],
            "singular": [
                  "segundo"
            ]
      },
      "year": {
            "plural": [
                  "anos"
            ],
            "singular": [
                  "ano"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
